// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__4QvDx","spinning-circle":"Spinner_spinning-circle__Hnhym"};